module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: [{
      'weui-cell_vcode': _vm.addon,
      'weui-cell_warn': _vm.warn,
      'weui-cell_switch': _vm.isSwitch,
      'weui-cell_select weui-cell_select-before': _vm.selectBefore,
      'weui-cell_select': _vm.select,
      'weui-cell_select weui-cell_select-after': _vm.selectAfter
    }, 'weui-cell']
  }, [(_vm.label || _vm.selectBefore) ? _c('div', {
    staticClass: "weui-cell__hd"
  }, [(!_vm.select && !_vm.selectBefore) ? _c('label', {
    staticClass: "weui-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._t("selector-before")], true) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._t("selector"), _vm._v(" "), _vm._t("selector-after"), _vm._v(" "), (!_vm.select && !_vm.selectAfter) ? _c('input', {
    staticClass: "weui-input",
    attrs: {
      "type": _vm.setInputObj.type,
      "placeholder": _vm.setInputObj.placeholder,
      "pattern": _vm.setInputObj.pattern,
      "autofocus": _vm.setInputObj.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "click": _vm.onItemClick,
      "input": _vm.onItemInput,
      "change": _vm.onItemChange,
      "focus": _vm.onItemFocus,
      "blur": _vm.onItemBlur
    }
  }) : _vm._e()], true), _vm._v(" "), (_vm.addon) ? _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._t("addon")], true) : _vm._e(), _vm._v(" "), (_vm.warn) ? _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('i', {
    staticClass: "weui-icon-warn"
  })]) : _vm._e(), _vm._v(" "), (_vm.sucess) ? _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('i', {
    staticClass: "weui-icon-success"
  })]) : _vm._e(), _vm._v(" "), (_vm.isSwitch) ? _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._t("switch")], true) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6a2e01c5!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/input.vue
// module id = 258
// module chunks = 0